// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { onePageCheckoutShippingSectionStyles } from "@bg/Overrides/Widgets/OnePageCheckout/OnePageCheckoutShippingSection";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import xScreen from "@bg/XDL/Utilities/xScreen";
import { css } from "styled-components";

onePageCheckoutShippingSectionStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 1fr;
        gap: ${fontConfig.spacing.smallHeading};
    `,
};

onePageCheckoutShippingSectionStyles.titleGridItem = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        gap: 8px;
    `,
};

onePageCheckoutShippingSectionStyles.titleText = {
    variant: "h3",
    css: css`
        margin-bottom: 0;
    `,
};

onePageCheckoutShippingSectionStyles.changeFulfillmentLink = {
    icon: {
        iconProps: {
            src: "ArrowRight",
            color: "primary",
            size: 17,
        },
        position: "right",
    },
};

onePageCheckoutShippingSectionStyles.addressContainer = {
    css: css`
        display: grid;
        grid-template-columns: 1fr 1fr;
        justify-content: space-between;
        gap: 24px 60px;
        width: 100%;
        ${xScreen("lte", "md")} {
            grid-template-columns: 1fr;
        }
    `,
};
